import { SystemPromptCard, WelcomeMessagesCard } from "@/components/agent/details";
import { CoreDrawer } from "@/components/common/CoreDrawer";
import { Agent } from "@/types/agent/agent";

interface GeniePromptDrawerProps {
  genie: Agent;
  isOpen: boolean;
  onClose: () => void;
}

export default function GeniePromptDrawer({ genie, isOpen, onClose }: GeniePromptDrawerProps) {
  const brand = genie.branding?.primaryColor ?? "#4E9CFF";

  return (
    <CoreDrawer
      isOpen={isOpen}
      onClose={onClose}
      title="Genie Prompt"
      description="Configure the welcome messages and system prompt that define how your genie thinks and speaks."
    >
      <div className="grid grid-cols-1 xl:grid-cols-2 gap-6 xl:items-stretch">
        <WelcomeMessagesCard agent={genie} brand={brand} />
        <SystemPromptCard agent={genie} brand={brand} />
      </div>
    </CoreDrawer>
  );
}
